<template>
  <div class="export-btn-box" :class="{ 'export-btn-box-mobile': creatorStudio.isMobile }">
    <div class="export-btn" v-bind:class="{ 'disabled': complete !== true, 'glow': complete === true}" @click="exportJob">
      <i v-if="!loading" class="far fa-download"></i>
      <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
      {{ 'Download' | trans }}
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import Analytics from "../../util/Analytics";

export default {
  name: "ExportBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    async exportJob() {
      if (this.complete) {
        await Analytics.send('creator_studio_action', `export_btn`, this.currentJob);

        JobManager.export(this.id);
      }
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.export-btn {
  background: #1266F1;
  color: white;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 17.5px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #1161e5;
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}

.export-btn-box-mobile {
  padding: 10px 20px;
  border-top: 1px solid #595959;
  background: #272727;

  .export-btn {
    height: 55px;
  }
}
</style>
